import {Table} from "react-bootstrap";
import React from "react";
import TableRow from "./TableRow";

const styles = {
    tableCell: {
        background: '#fff',
    }
}

export default function TableInfo(props) {
    return (
        <Table responsive bordered>
            <thead>
            <tr>
                <th key="№" className="center" style={styles.tableCell}>№</th>
                {
                    props.columns.map(column => {
                        return(
                            <th key={column.name} className="center" style={styles.tableCell}>{column.name}</th>
                        )
                    })
                }
                <th className="center" style={styles.tableCell}>Action</th>
            </tr>
            </thead>
            <tbody>
            {
                props.rows.map((row, rowIndex) => {
                    return(
                        <TableRow key={rowIndex} row={row} rowIndex={rowIndex} columns={props.columns}
                                  addRow={props.addRow} deleteRow={props.deleteRow} moveUpRow={props.moveUpRow}
                                  moveDownRow={props.moveDownRow} setTagValue={props.setTagValue}
                                  oninputCell={props.oninputCell} />
                    )
                })
            }
            </tbody>
        </Table>
    )
}